import React, {useEffect, useMemo} from 'react';
import Select from 'react-select';
import {
  amlUserCheckedBlue,
  amlUserCheckedGreen,
} from '../../../assets/images/images';
import {Card, CATEGORIES, Wrapper} from '../FraudCheckScreens';
import {Checkbox, customStyles, DropdownIndicator} from '../../../components';
import {useFraudCheck, usePersistFraudData} from '../../../hooks/useFraudCheck';

export const DetectWithAmlScreening = () => {
  const {
    setSelectedStatus,
    selectedStatus,
    setConfig,
    config,
    STATUSES,
    setSelectedCategory,
    selectedCategory,
    setSelectedMatchScore,
  } = useFraudCheck({
    action_returned: 'pending',
    category: ['pep', 'warning'],
    match_score: 50,
  });
  const actionReturned = usePersistFraudData({
    config,
    selectedStatus,
    actionKey: 'action_returned',
    COLLECTION: STATUSES,
  });

  const rangeTextPosition = useMemo(
    () => (Number(config?.match_score || 50) / 100) * 100,
    [config?.match_score],
  );

  useEffect(() => {
    if (config) {
      if (!config?.category || config?.category?.length === 0) {
        setSelectedCategory(['pep', 'warning']);
        setConfig({...config, category: ['pep', 'warning']});
      }
      if (!config?.match_score) {
        setSelectedMatchScore(50);
        setConfig({
          ...config,
          match_score: 50,
          action_returned: config?.action_returned,
        });
      }
    }
  }, [config, setConfig, setSelectedCategory, setSelectedMatchScore]);

  return (
    <Wrapper>
      <Card
        extension={
          <div className="flex flex-col gap-1">
            <p className="text-grey font-medium">AML Category</p>
            <p className="text-body text-sm gap-1">
              Select the AML category you want to screen your user against
            </p>
          </div>
        }
        src={amlUserCheckedGreen}
      >
        {CATEGORIES.map((category, idx) => (
          <div className=" w-full  cursor-pointer" key={idx}>
            <div className="bg-white80 rounded-md pl-3 ">
              <Checkbox
                label={category?.replaceAll('_', ' ')}
                className="py-[12px] uppercase cursor-pointer"
                labelStyle=" text-body leading-[18px] cursor-pointer"
                align="items-start"
                isChecked={selectedCategory?.includes(category)}
                onChange={e => {
                  if (e.target.checked) {
                    setSelectedCategory(prev => [...prev, category]);
                    setConfig({
                      ...config,
                      category: [...selectedCategory, category],
                    });
                  } else {
                    const updatedCategory = selectedCategory?.filter(
                      category => e.target.value !== category,
                    );
                    setSelectedCategory(updatedCategory);
                    setConfig({...config, category: updatedCategory});
                  }
                }}
                value={category}
                noLeftPadding
              />
            </div>
          </div>
        ))}
      </Card>
      <Card
        extension={
          <div className="flex flex-col gap-1">
            <p className="text-grey font-medium">AML Match Score</p>
            <p className="text-body text-sm gap-1">
              Set a confidence threshold to determine how strict the matching
              should be
            </p>
          </div>
        }
        src={amlUserCheckedBlue}
      >
        <div className="liveness_slider match_score w-full">
          <input
            type="range"
            min="0"
            max="100"
            value={config?.match_score?.toString() || '40'}
            onChange={e => {
              setSelectedMatchScore(+e.target.value);
              setConfig({...config, match_score: +e.target.value});
            }}
            className="w-full h-8 appearance-none bg-gray-200 rounded-full outline-none cursor-pointer"
            style={{
              // Style the track
              background: `linear-gradient(to right, #3F7CDB 0%, #3F7CDB ${config?.match_score}%, #e5e7eb ${config?.match_score}%, #e5e7eb 100%)`,
            }}
          />
        </div>
        <div className="relative flex justify-between items-center w-full">
          <p
            className={`text-body font-medium text-xs
            ${config?.match_score < 1 ? 'invisible' : ''}`}
          >
            0
          </p>
          <p
            className="text-body font-bold text-sm absolute"
            style={{
              left: `${rangeTextPosition}%`,
              transform: 'translateX(-50%)',
            }}
          >
            {config?.match_score}
          </p>
          <p
            className={`text-body font-medium text-xs ml-auto
            ${config?.match_score > 96 ? 'invisible' : ''}
          `}
          >
            100
          </p>
        </div>
      </Card>

      <Card
        extension={<p className="text-grey font-medium">If info is returned</p>}
        src={amlUserCheckedGreen}
      >
        <div className="text-start w-full">
          <label htmlFor="status" className="mb-2 relative">
            Set status to
          </label>
          {actionReturned !== undefined && (
            <Select
              defaultValue={actionReturned}
              value={actionReturned || STATUSES[0]}
              onChange={status => {
                setSelectedStatus(status);
                setConfig({...config, action_returned: status.value});
              }}
              options={STATUSES}
              className="basic-multi-select"
              classNamePrefix="react-select"
              components={{DropdownIndicator}}
              styles={customStyles}
              menuPlacement="auto"
              isSearchable={false}
            />
          )}
        </div>
      </Card>
      {/*<Card*/}
      {/*  extension={*/}
      {/*    <p className="text-grey font-medi  um">If no info is returned</p>*/}
      {/*  }*/}
      {/*  src={eyeCapRed}*/}
      {/*>*/}
      {/*  <div className="text-start w-full">*/}
      {/*    <label htmlFor="status" className="mb-2 relative">*/}
      {/*      Set status to*/}
      {/*    </label>*/}
      {/*    {actionNotReturned !== undefined && (*/}
      {/*      <Select*/}
      {/*        defaultValue={actionNotReturned}*/}
      {/*        onChange={status => {*/}
      {/*          setSelectedStatus(status);*/}
      {/*          setConfig({...config, action_not_returned: status.value});*/}
      {/*        }}*/}
      {/*        options={STATUSES}*/}
      {/*        className="basic-multi-select"*/}
      {/*        classNamePrefix="react-select"*/}
      {/*        components={{DropdownIndicator}}*/}
      {/*        styles={customStyles}*/}
      {/*        menuPlacement="auto"*/}
      {/*      />*/}
      {/*    )}*/}
      {/*  </div>*/}
      {/*</Card>*/}
    </Wrapper>
  );
};
